<script setup lang="ts">
import { computed } from 'vue';
import {
  mdiBookOpenPageVariantOutline,
  mdiViewGridOutline,
  mdiCheckboxMarkedCircleOutline,
} from '@quasar/extras/mdi-v7';

const props = defineProps<{
  averageScore: {
    steps: number | null;
    sections: number | null;
    courses: number | null;
  };
}>();

function fmt(value: number | null): string {
  return typeof value === 'number' ? `${Math.round(value)}%` : '–';
}

const rows = computed(() => [
  {
    key: 'courses',
    acc: 'acc-courses',
    icon: mdiBookOpenPageVariantOutline,
    label: 'COURSES',
    value: fmt(props.averageScore.courses),
  },
  {
    key: 'sections',
    acc: 'acc-sections',
    icon: mdiViewGridOutline,
    label: 'SECTIONS',
    value: fmt(props.averageScore.sections),
  },
  {
    key: 'steps',
    acc: 'acc-steps',
    icon: mdiCheckboxMarkedCircleOutline,
    label: 'STEPS',
    value: fmt(props.averageScore.steps),
  },
]);
</script>
<template>
  <div class="stat-card">
    <div class="stat-card__head">
      <div class="stat-card__title">{{ $t('AVERAGE_SCORE') }}</div>
    </div>
    <div class="stat-rows">
      <div
        v-for="row in rows"
        :key="row.key"
        class="stat-row"
        :class="row.acc"
      >
        <div class="stat-badge stat-badge--sm">
          <q-icon
            :name="row.icon"
            size="18px"
          />
        </div>
        <div class="stat-row__text">
          <div class="stat-label">{{ $t(row.label) }}</div>
        </div>
        <div class="stat-row__value">{{ row.value }}</div>
      </div>
    </div>
  </div>
</template>
